<template>
  <div
    class="icon-wrapper"
    :class="[active ? 'active' : '']"
    @click="emit('click')"
  >
    <div class="icon-button">
      <slot v-if="slots.default"></slot>
      <img v-else-if="isGif" :src="resolvedIcon" alt="icon" class="gif-icon" />
      <i
        v-else
        class="tr"
        :class="[`tr-${icon}`]"
      ></i>
    </div>
  </div>
</template>

<script setup>
import { computed, defineProps, defineEmits, useSlots } from 'vue';

const images = require.context('@/assets', false, /\.gif$/);
const slots = useSlots();

const props = defineProps({
  icon: {
    type: String,
    required: false,
  },
  active: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['click']);

const isGif = computed(() => {
  return !!props.icon && props.icon.endsWith('.gif');
});

const resolvedIcon = computed(() => {
  try {
    const fileName = `./${props.icon.split('/').pop()}`;
    return isGif.value ? images(fileName) : props.icon;
  } catch {
    return props.icon;
  }
});
</script>

<style lang="scss" scoped>
.icon-button {
  display: flex;
  align-items: center;
  .tr {
    display: flex;
    align-items: center;
    color: var(--text);
  }
}
.icon-button:hover {
  .tr {
    opacity: 1;
  }
}
.icon-wrapper {
  cursor: pointer;
  position: relative;
  display: flex;
  justify-content: center;
  width: 24px;
  height: 24px;
  background: var(--input);
  border-radius: 5px;
  opacity: 0.3;
}
.active {
  .icon-wrapper {
    opacity: 1;
  }
  .tr {
    color: var(--accent);
  }
}
.icon-wrapper:hover {
  opacity: 1;
}

.gif-icon {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

</style>
